import { Box } from "@mui/material";
import React from "react";

interface SelectOptionBreadcrumbsProps {
  options: string[];
  selectedOption: string;
  handleSelectOption: (option: string) => void;
}

export const SelectOptionBreadcrumbs = ({
  options,
  selectedOption,
  handleSelectOption,
}: SelectOptionBreadcrumbsProps) => {
  return (
    <Box className="breadcrumbs-options">
      {options.map((option, i) => (
        <Box
          key={i}
          className={`breadcrumbs-option ${
            selectedOption.toLowerCase() === option.toLowerCase() && "active-option"
          }`}
          onClick={() => handleSelectOption(option)}
        >
          {option}
        </Box>
      ))}
    </Box>
  );
};
